export default "__VITE_PUBLIC_ASSET__27f8d72b__"